import React, { useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';

import {
  SubtitleSecondary,
  Paragraph,
  InputSelect,
  InputText,
  InputRadio,
  ButtonMain,
} from '@components/index';
import { ConfigLabel } from '@config/index';
import { apiRebox } from '@services/index';
import { toastify } from '@utils/notifiers';

import {
  Container,
  DividingLine,
  FormNewVehicle,
  Sections,
  SectionsGroup,
  SectionsItem,
} from './styles';

const FormAddNewVehicle: React.FC = () => {
  const FormNewVehicleRef = useRef<FormHandles>(null);
  const [classification, setClassification] = useState<string>('');
  const [brand, setBrand] = useState<string>('');
  const [model, setModel] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [isForTrackerPlan, setIsForTrackerPlan] = useState<string>('');

  const handlePostCar = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.post('/cars', {
        brand,
        model,
        classification,
        status,
        is_for_tracker_plan: isForTrackerPlan === 'yes',
      });
      const { header } = response;
      toastify(header.message, 'success');
    } catch (error: any) {
      if (error.response) {
        toastify(error.response.data.error, 'error');
      } else {
        toastify(
          'Houve um erro ao tentar adicionar o modelo de veiculo',
          'error',
        );
      }
    }
  }, [classification, brand, model, status, isForTrackerPlan]);

  return (
    <Container>
      <FormNewVehicle
        ref={FormNewVehicleRef}
        onSubmit={handlePostCar}
        initialData={{}}
      >
        <Sections>
          <SubtitleSecondary textAlign="start" nameColor="black" fontSize={18}>
            Adicione um novo modelo veicular
          </SubtitleSecondary>
          <Paragraph
            nameColor="black"
            textAlign="start"
            opacity={0.5}
            fontSize={15}
            style={{ marginBottom: '2vh' }}
          >
            Aqui será adicionado novos modelos a listagem de veículos.
          </Paragraph>

          <DividingLine />

          <SubtitleSecondary textAlign="start" nameColor="black" fontSize={18}>
            Informações do veículo
          </SubtitleSecondary>
          <Paragraph
            nameColor="black"
            textAlign="start"
            opacity={0.5}
            fontSize={13}
            style={{ marginBottom: '2vh' }}
          >
            Informe as características do novo modelo
          </Paragraph>
          <SectionsGroup>
            <SectionsItem>
              <SubtitleSecondary
                textAlign="start"
                nameColor="black"
                fontSize={16}
              >
                Classificação
              </SubtitleSecondary>
              <InputSelect
                name="classification"
                onChange={(event: any) => setClassification(event.target.value)}
                options={ConfigLabel.rebox.others.vehicle.classifications}
                placeholder="Selecione"
              />
            </SectionsItem>
            <SectionsItem>
              <SubtitleSecondary
                textAlign="start"
                nameColor="black"
                fontSize={16}
              >
                Marca
              </SubtitleSecondary>
              <InputText
                name="brand"
                placeholder="Digite o nome da marca"
                onChange={(event: any) => setBrand(event.target.value)}
              />
            </SectionsItem>
          </SectionsGroup>
          <SectionsGroup>
            <SectionsItem>
              <SubtitleSecondary
                textAlign="start"
                nameColor="black"
                fontSize={16}
              >
                Modelo
              </SubtitleSecondary>
              <InputText
                name="model"
                placeholder="Digite o nome do modelo"
                onChange={(event: any) => setModel(event.target.value)}
              />
            </SectionsItem>
            <Sections>
              <SubtitleSecondary
                textAlign="start"
                nameColor="black"
                fontSize={16}
              >
                Status
              </SubtitleSecondary>
              <InputSelect
                options={ConfigLabel.rebox.others.vehicle.status}
                name="status"
                placeholder="Informe o status do modelo"
                onChange={(event: any) => setStatus(event.target.value)}
              />
            </Sections>
          </SectionsGroup>
          <SectionsGroup>
            <SectionsItem>
              <SubtitleSecondary
                textAlign="start"
                nameColor="black"
                fontSize={16}
              >
                Para rastreador
              </SubtitleSecondary>
              <InputRadio
                name="tracker"
                onChange={(event: any): void =>
                  setIsForTrackerPlan(event.target.value)
                }
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                row={true}
              />
            </SectionsItem>
            <ButtonMain>Adicionar novo veículo</ButtonMain>
          </SectionsGroup>
        </Sections>
      </FormNewVehicle>
    </Container>
  );
};

export default FormAddNewVehicle;
